import useAthleteActions from "providers/AthletesProvider/useAthleteActions";
import useMutation from "hooks/useMutation";

export interface UseAthleteUpdateEmailMutationProps {
  athleteId: string;
}

export interface AthleteUpdateEmailArg {
  athleteId: string;
  email: string;
}

/**
 * @description Sets the athlete's pending email address, which invites them to Capture.
 * Goes through the athletes store so the athlete held there is updated alongside the request,
 * without an extra fetch.
 */
function useAthleteUpdateEmailMutation(props: UseAthleteUpdateEmailMutationProps) {
  const queryKey = ["AthleteService.updateEmail", props.athleteId];
  const { updateEmail } = useAthleteActions();

  return useMutation<void, Error, typeof queryKey, AthleteUpdateEmailArg>(queryKey, async (_, { arg }) =>
    updateEmail(arg.athleteId, arg.email)
  );
}

export default useAthleteUpdateEmailMutation;
